import semver from 'semver';

export function extractMajorMinor(versionString: string): string {
  const parsedVersion = semver.parse(semver.coerce(versionString));
  if (parsedVersion) {
    const major = parsedVersion.major;
    const minor = parsedVersion.minor;
    return `v${major}.${minor}`;
  } else {
    return '';
  }
}

export function extractMajorMinorPatch(versionString: string): string {
  const parsedVersion = semver.parse(semver.coerce(versionString));
  if (parsedVersion) {
    const major = parsedVersion.major;
    const minor = parsedVersion.minor;
    const patch = parsedVersion.patch;
    return `v${major}.${minor}.${patch}`;
  } else {
    return '';
  }
}
